class CancelReason {
  constructor(note) {
    this.note = note;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      cancelReasonId: null,
      searchTitle: '',
      disabelConfirm: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.confimType = 'add';
        for (let i = 0; i < this.allCancelReasons.length; i++) {
          if (this.allCancelReasons[i].id == 0) {
            return;
          }
        }
        this.allCancelReasons.push({ note: '', isEdit: true, id: 0 });
      } else if (type == 2) {
        this.confimType = 'edit';
        let temp = this.allCancelReasons;
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].isEdit = true;
          }
        }
        this.allCancelReasons = [];
        this.allCancelReasons = temp;
        this.getCancelReasonFunction(id);
      }
    },
    cancelAddEditFunction: function (id) {
      this.cancelReason = new CancelReason('');
      for (var i = 0; i < this.allCancelReasons.length; i++) {
        if (this.allCancelReasons[i].id == id) {
          if (id == 0) {
            this.allCancelReasons.splice(i, 1);
          }
          this.allCancelReasons[i].isEdit = false;
        }
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addCancelReasonFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش علل 19-10';
        this.$refs.confirm.text = 'از ویرایش علل 19-10 اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف علل 19-10';
        this.$refs.confirm.text = 'از حذف علل 19-10 اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'active') {
        this.$refs.confirm.title = 'فعال کردن علت 19-10';
        this.$refs.confirm.text = 'از فعال کردن علت 19-10 اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'deActive') {
        this.$refs.confirm.title = 'غیر فعال کردن علت 19-10';
        this.$refs.confirm.text = 'از غیر فعال کردن علت 19-10 اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addCancelReasonFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editCancelReasonFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deleteCancelReasonFunction();
      } else if (this.confimType == 'active') {
        this.disabelConfirm = true;
        this.cancelReason.isActive = true;
        this.editCancelReasonFunction();
      } else if (this.confimType == 'deActive') {
        this.disabelConfirm = true;
        this.cancelReason.isActive = false;
        this.editCancelReasonFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'active') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'deActive') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.cancelReasonId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    //changeStatus
    changeStatus: function (type, data) {
      if (type == 1) {
        //باید غیر فعال شود
        this.cancelReason = data;
        this.confimType = 'deActive';
        this.showConfirmDialogFunction();
      } else if (type == 2) {
        //باید فعال شود
        this.cancelReason = data;
        this.confimType = 'active';
        this.showConfirmDialogFunction();
      }
    },
  },
};
